import Vue from 'vue'
import Loading from './components/shared/Loading.vue'

Vue.component('Loading', Loading)
